import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers';

import { ApiService } from '../../core/api.service';
import { User, ErrCode } from '../../shared/models';
import { LoggerService } from '../../core/logger.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'sync-verify-email',
    templateUrl: './verify-email.component.html'
})
export class VerifyEmailComponent implements OnInit {

    public confirmcode: string;
    public user: User;
    public errcode: ErrCode;
    public spinner: boolean;

    public authenticated: boolean;
    constructor(
        private api: ApiService,
        private log: LoggerService,
        private store: Store<fromRoot.State>,
        private router: Router,
        private route: ActivatedRoute
    ) { }

    ngOnInit() {
        this.spinner = false;
        this.errcode = undefined;
        this.store
            .select(fromRoot.getAuthState)
            .subscribe((data) => {
                this.authenticated = data.authenticated;
                if (!data.authenticated) {
                    this.user = new User();
                    return;
                }
                if (data.user) {
                    this.user = data.user;
                }
            });
        this.confirmcode = this.route.snapshot.queryParams['c'];

        if (this.confirmcode) {
            this.verify();
        } else {
            this.errcode = new ErrCode(8103, 'No confirmation code provided');
        }
    }

    public async verify() {
        this.spinner = true;
        try {
            const result = await this.api.send('userverifyemail', {
                verify_code: this.confirmcode
            });
            if (this.authenticated && this.user.id == result['user_id']) {
                const newState = '/files';
                this.router.navigate([newState], { queryParams : undefined });
            } else {
                this.router.navigate(['/login'], { queryParams : { verified: 1 } });
            }
        } catch (ex) {
            this.log.error('Unable to verify email ');
            this.log.error(ex);
            this.errcode = ErrCode.fromException(ex);
        }
        this.spinner = false;
    }

    public async resendVerification() {
        try {
            await this.api.execute('userverifyemailresend', {});
        } catch (ex) {
            this.errcode = ErrCode.fromException(ex);
        }
    }
}
